module.exports = __webpack_public_path__ + "img/6.0547a05c.jpg";